import { Flex, useDisclosure, VStack } from "@chakra-ui/react";
import { lazy, Suspense, useEffect, useState } from "react";
import { ListDashboardNotification } from "../../../components/dashboard_reseller/ListDashboardNotification";
import { ProfileResellerStatistic } from "../../../components/dashboard_reseller/ProfileResellerStatistic";
import { RecentOrder } from "../../../components/dashboard_reseller/RecentOrder";
import LazyLoadOnScroll from "../../../components/LazyLoadOnScroll";
import { ConfirmationPermissionModal } from "../../../components/modal/ConfirmationPermissionModal";
import { CardSkeleton } from "../../../components/skeleton/CardSkeleton";
import { DashboardResellerInterface } from "../../../constants/DashboardReseller";
import useCustomToast from "../../../lib/useCustomToast";
import { axiosReseller } from "../../../utils/AxiosInstance";
import { getModalPermission } from "../../../utils/helperFunction";

const AnalyticDeviceTypeChart = lazy(
  () => import("../../../components/dashboard_reseller/AnalyticDeviceTypeChart")
);

const AnalyticLineChart = lazy(
  () => import("../../../components/chart/AnalyticLineChart")
);

export const DashboardReseller = () => {
  const [data, setData] = useState<DashboardResellerInterface | undefined>(
    undefined
  );
  const [loaded, setLoaded] = useState<boolean>(false);
  const toast = useCustomToast();
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    if (getModalPermission()) {
      onOpen();
    }
  }, []);

  useEffect(() => {
    axiosReseller
      .get(`/v1/reseller/dashboardv2`)
      .then((res) => {
        setData(res.data.data);
      })
      .catch((err) => {
        toast({
          description: err?.response?.data?.message || "",
        });
      })
      .finally(() => {
        setLoaded(true);
      });
  }, []);

  return (
    <>
      <VStack
        className="dashboard-reseller-page"
        w={"100%"}
        p={4}
        gap={4}
        align={"stretch"}
        overflowX={"clip"}
      >
        <ProfileResellerStatistic data={data} loaded={loaded} />

        <Flex
          w={"100%"}
          gap={4}
          flexDirection={[
            "column",
            "column",
            "column",
            "column",
            "column",
            "row",
            "row",
          ]}
          alignItems={"start"}
        >
          <LazyLoadOnScroll flex={3}>
            <Suspense fallback={<CardSkeleton row={1} height={400} />}>
              <AnalyticLineChart
                data={data?.analytic.analyticViewer}
                title="Analitik Link Dibuka"
              />
            </Suspense>
          </LazyLoadOnScroll>

          <LazyLoadOnScroll flex={1}>
            <Suspense fallback={<CardSkeleton row={1} height={400} />}>
              <AnalyticDeviceTypeChart data={data?.analytic.analyticDevice} />
            </Suspense>
          </LazyLoadOnScroll>
        </Flex>

        <Flex
          w={"100%"}
          gap={4}
          flexDirection={["column", "column", "column", "row", "row"]}
          alignItems={"start"}
          overflow={"auto"}
        >
          <RecentOrder data={data?.purchases} flex={[1, null, 4]} />

          <ListDashboardNotification
            data={data?.notification}
            flex={[1, null, 2]}
          />
        </Flex>
      </VStack>

      <ConfirmationPermissionModal
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
        children={undefined}
      />
    </>
  );
};
